@if (form) {
  <ng-container [formGroup]="form">
    @if (fieldData.form.display?.visible) {
      <div>
        <div class="">
          <div class="uk-form-controls">
            @if (fieldData.typeInfo.type === 'composite') {
              <div>
                <app-composite-field [fieldData]="fieldData" [readonly]="readonly" [editMode]="editMode"
                                     [scrollContainer]="scrollContainer"
                                     (hasChanges)="unsavedChangesPrompt()"
                                     (handleBitSets)="handleBitsetOfChildren($event)"
                                     (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                </app-composite-field>
              </div>
            }
            @if (fieldData.typeInfo.type === 'chooseOne') {
              <div>
                <app-choose-one [fieldData]="fieldData" [editMode]="editMode"
                                (hasChanges)="unsavedChangesPrompt()" (handleBitSets)="handleBitsetOfChildren($event)"
                                (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)" >
                </app-choose-one>
              </div>
            }
            @if (fieldData.typeInfo.type === 'string' || fieldData.typeInfo.type === 'url' || fieldData.typeInfo.type === 'email' || fieldData.typeInfo.type === 'phone' ) {
              <app-string-url-email-field [fieldData]="fieldData" [editMode]="editMode" [readonly]="readonly"
                                          [scrollContainer]="scrollContainer"
                                          (hasChanges)="unsavedChangesPrompt()"
                                          (handleBitSets)="handleBitsetOfChildren($event)"
                                          (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
              </app-string-url-email-field>
            }
            @if (fieldData.typeInfo.type === 'number') {
              <div>
                <app-number-field [fieldData]="fieldData" [editMode]="editMode" [readonly]="readonly"
                                  [scrollContainer]="scrollContainer"
                                  (hasChanges)="unsavedChangesPrompt()"
                                  (handleBitSets)="handleBitsetOfChildren($event)"
                                  (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                </app-number-field>
              </div>
            }
            @if (fieldData.typeInfo.type === 'checkbox') {
              <div>
                <app-boolean-field [fieldData]="fieldData" [editMode]="editMode" [readonly]="readonly"
                                   [scrollContainer]="scrollContainer"
                                   (hasChanges)="unsavedChangesPrompt()"
                                   (handleBitSets)="handleBitsetOfChildren($event)"
                                   (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                </app-boolean-field>
              </div>
            }
            @if (fieldData.typeInfo.type === 'bool') {
              <div>
                <app-boolean-field [fieldData]="fieldData" [editMode]="editMode" [readonly]="readonly"
                                   [scrollContainer]="scrollContainer"
                                   (hasChanges)="unsavedChangesPrompt()"
                                   (handleBitSets)="handleBitsetOfChildren($event)"
                                   (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                </app-boolean-field>
              </div>
            }
            @if (fieldData.typeInfo.type === 'select') {
              <app-select-field [fieldData]="fieldData" [editMode]="editMode" [readonly]="readonly"
                                [scrollContainer]="scrollContainer" (hasChanges)="unsavedChangesPrompt()">
              </app-select-field>
            }
            @if (fieldData.typeInfo.type === 'vocabulary') {
              <div>
                <app-vocabulary-field [fieldData]="fieldData" [editMode]="editMode" [readonly]="readonly"
                                      [scrollContainer]="scrollContainer"
                                      (hasChanges)="unsavedChangesPrompt()">
                </app-vocabulary-field>
              </div>
            }
            @if (fieldData.typeInfo.type === 'largeText') {
              <div>
                <app-large-text-field [fieldData]="fieldData" [editMode]="editMode" [readonly]="readonly"
                                      [scrollContainer]="scrollContainer"
                                      (hasChanges)="unsavedChangesPrompt()"
                                      (handleBitSets)="handleBitsetOfChildren($event)"
                                      (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                </app-large-text-field>
              </div>
            }
            @if (fieldData.typeInfo.type === 'radio') {
              <div>
                <app-radio-button-field [fieldData]="fieldData" [readonly]="readonly"
                                        [scrollContainer]="scrollContainer"
                                        (hasChanges)="unsavedChangesPrompt()"
                                        [editMode]="editMode" (handleBitSets)="handleBitsetOfChildren($event)"
                                        (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                </app-radio-button-field>
              </div>
            }
            @if (fieldData.typeInfo.type === 'richText') {
              <div>
                <app-rich-text-field [fieldData]="fieldData" [editMode]="editMode" [readonly]="readonly"
                                     [scrollContainer]="scrollContainer"
                                     (hasChanges)="unsavedChangesPrompt()"
                                     (handleBitSets)="handleBitsetOfChildren($event)"
                                     (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                </app-rich-text-field>
              </div>
            }
            @if (fieldData.typeInfo.type === 'date') {
              <div>
                <app-date-field [fieldData]="fieldData" [editMode]="editMode" [readonly]=readonly
                                [scrollContainer]="scrollContainer"
                                (hasChanges)="unsavedChangesPrompt()"
                                (handleBitSets)="handleBitsetOfChildren($event)"
                                (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                </app-date-field>
              </div>
            }
            @if (fieldData.typeInfo.type === 'scale') {
              <div>
                <app-scale-field [fieldData]="fieldData" [editMode]="editMode"
                                 (hasChanges)="unsavedChangesPrompt()"
                                 (handleBitSets)="handleBitsetOfChildren($event)"
                                 (handleBitSetsOfComposite)="handleCompositeBitsetOfChildren($event)">
                </app-scale-field>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </ng-container>
}
